export const oldErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (createtime !== undefined) {
		const currenttime = new Date()
		const errorcreatetime = new Date(createtime)

		// 8 * 60 * 60 * 1000 = 43200000 - 12 hours in milliseconds
		if (currenttime.getTime() - errorcreatetime.getTime() > 43200000) {
			return {
				type: 'oldErrorTest',
				nonError: true,
				color: 'Goldenrod',
				title: '[!] Old lastException File',
				text: 'The lastException file you have provided is old!',
				description: 'To accurately test for errors in the provided lastException file, make sure to send the most recent file you have.<br/><br/><em>This file is at least 12 hours old.</em>'
			}
		}
	}
}

export const veryOldErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (createtime !== undefined) {
		const currenttime = new Date()
		const errorcreatetime = new Date(createtime)

		// 30 * 60 * 60 * 1000 = 172800000 - 48 hours in milliseconds
		if (currenttime.getTime() - errorcreatetime.getTime() > 172800000) {
			return {
				type: 'oldErrorTest',
				nonError: true,
				color: 'IndianRed',
				title: '[!!] Very Old lastException File',
				text: 'The lastException file you have provided is very old!',
				description: 'To accurately test for errors in the provided lastException file, you are required to send the most recent file you have.<br/><br/><em>This file is unacceptable, it\'s at least 48 hours old.</em>'
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/tests/critical/oldErrorTest.js